/**
 * 文字列群を日本語に配慮しながらソートする
 */
export const localeAwareSort = (a: string, b: string) =>
  a.localeCompare(b, 'ja', { sensitivity: 'case' })
